import CookieUtil from "../../../../lib/html5-software-library/src/ranj/util/CookieUtil";
import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import Config from "../../app/config/Config";
import AppModel from "../../app/core/AppModel";
import ISaveModel from "../savegame/ISaveModel";
import SaveEvent from "../savegame/SaveEvent";
import PlatformAPIEventType from "./PlatformAPIEventType";
import PlatformAPIService from "./PlatformAPIService";

export default class MockPlatformAPIService extends PlatformAPIService {

    /**
     * @param {AppModel} appModel 
     * @param {ISaveModel} saveModel 
     * @param {Config} config 
     */
    constructor(appModel, saveModel, config, dispatcher) {
        super(appModel, saveModel);
        this._config = config;
        this._dispatcher = dispatcher;
    }

    initialize(version) {
        this._version = version;
        this._api = {
            getConfiguration: () => {
                return {
                    language: "en",
                    interaction_state: this._load(),
                    play_mode: "assessment",
                    environment: this._config.getValue(Config.ENVIRONMENT),
                }
            },
            getConfigurationAsync: () => {
                return new Promise(resolve => {
                    setTimeout(_ => {
                        resolve({
                            language: "en",
                            interaction_state: this._load(),
                            play_mode: "assessment",
                            environment: this._config.getValue(Config.ENVIRONMENT),
                        });
                    }, parseInt(getURLParameter('apitimeout')) || 100);
                });
            },
            sendEvent: (eventType, payload) => {
                switch (eventType) {
                    case PlatformAPIEventType.SAVE_REQUEST:
                        this._save(payload.interaction_state);
                        break;
                }
                return true;
            },
            exit: () => {
                this._dispatcher.dispatch(SaveEvent.CLEAR);
                window.location.reload();
            }
        }

        if (this.supportsGetConfigurationAsync()) {
            return this.getConfigurationAsync();
        } else {
            const platformParameters = this.getConfigurationSync();
            return Promise.resolve(platformParameters);
        }
    }

    _save(str) {
        window.localStorage.setItem(this._getCookieName(), str);
    }
    _load() {
        return window.localStorage.getItem(this._getCookieName());
    }
    _getCookieName() {
        return this._config.getValue(Config.APPID);
    }

}